import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import Button from "./Button";
import ReactMarkdown from "react-markdown";

const InfoModal = ({
  open,
  setOpen,
  title,
  body,
  buttonText = "Okay",
  fullWidthButton = false,
  markdown = false,
}) => {
  if (markdown) {
    body = <ReactMarkdown className="markdown">{body}</ReactMarkdown>;
  } else {
    // if body is a function, render it as a component, otherwise render as text
    if (typeof body === "function") {
      body = <div>{body()}</div>;
    } else {
      body = <p>{body}</p>;
    }
  }

  return (
    <Dialog className="relative z-10" open={open} onClose={setOpen}>
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-dark-gray bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full justify-center text-center items-center">
          <DialogPanel
            transition
            className="relative my-8 w-full max-w-[475px] transform overflow-hidden transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="rounded-[24px] bg-white text-left shadow-xl overflow-hidden p-8">
              <h2 className="text-[22px] font-bold leading-[1.5] mb-4">
                {title}
              </h2>
              {body}
              <div className="mt-6 flex justify-end">
                <Button
                  fullWidth={fullWidthButton}
                  onClick={() => setOpen(false)}
                  variant="primary"
                >
                  {buttonText}
                </Button>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default InfoModal;
